module.exports = __webpack_public_path__ + "img/26b8d73.png";